<template>
  <div class="file-manager-file-picker-sidebar">

    <div v-if="isFolder(currentFile)" class="text-center preview-by-icon">
      <i class="fa fa-folder"></i>
    </div>

    <img v-else-if="isImage(currentFile)"
         id="file-manager-preview-image"
         :src="currentFile.webPath"
         class="img-fluid"
         alt="">

    <div v-else-if="isVideo(currentFile)" class="text-center preview-by-icon">
      <i class="fa fa-video"></i>
    </div>

    <div v-else-if="isFile(currentFile)" class="text-center preview-by-icon">
      <i class="fa fa-file"></i>
    </div>

    <div v-else class="text-center"></div>

    <table class="table">
      <tbody>
        <tr v-if="currentFile.name">
          <td>{{ t.__('Nazwa') }}</td>
          <td class="text-truncate">{{ currentFile.name }}</td>
        </tr>
        <tr v-if="currentFile.size">
          <td>{{ t.__('Rozmiar') }}</td>
          <td class="text-truncate">{{ currentFile.size | humanFileSize }}</td>
        </tr>
        <tr v-if="currentFile.dimensions && currentFile.dimensions.width && currentFile.dimensions.height">
          <td>{{ t.__('Wymiary') }}</td>
          <td class="text-truncate">{{ currentFile.dimensions.width }} x {{ currentFile.dimensions.height }} px</td>
        </tr>
        <tr>
          <td>{{ t.__('Typ') }}</td>
          <td class="text-truncate">{{ currentFile.mimeType }}</td>
        </tr>
        <tr v-if="currentFile.modified">
          <td>{{ t.__('Data') }}</td>
          <td class="text-truncate">{{ currentFile.modified }}</td>
        </tr>

      </tbody>
    </table>
  </div>
</template>

<script>
import fileManagerMixin from "../file-manager-mixin";

export default{

	mixins: [fileManagerMixin],

	props:{
		currentFile : {
			default: function(){
				return {};
			},
			type: [Object, Boolean]
		},
	}
};
</script>
